export enum EntityTypeEnum {
  None,
  Entity,
  List
}
